import { useCallback, useState } from 'react';

const storageKey = 'kds_nav_enabled';

/**
 * Per-device switch for the KDS entry in the header nav.
 *
 * Opt-in: hidden until a device explicitly turns it on, so rolling KDS out to a location does not
 * put the tab on every device there. Device-local by design — the same user on another device is
 * unaffected.
 */
export const useKdsNavEnabled = () => {
  const [enabled, setEnabled] = useState(() => localStorage.getItem(storageKey) === 'true');

  const toggle = useCallback(() => {
    setEnabled((previous) => {
      const next = !previous;
      localStorage.setItem(storageKey, String(next));
      return next;
    });
  }, []);

  return { enabled, toggle };
};
